import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "/api/files/local/logo-normal.png";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => navigate("/paneli"))
        .catch(() => localStorage.removeItem("admin_token"));
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      navigate("/paneli");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Email ose password i gabuar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)' }} data-testid="admin-login-page">
      <div className="w-full max-w-md" style={{ borderRadius: '5px', background: '#ffffff', padding: '50px 35px', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.06)' }}>
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Albanian Aligners Academy" className="h-16 w-auto mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#0A0D10]" style={{ fontFamily: "'Noto Sans', sans-serif" }}>Admin Panel</h1>
          <p className="text-sm text-[#828D9E] mt-2">Identifikohuni per te hyre ne panelin e administrimit</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"><Mail size={16} /></span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full rounded-lg border border-slate-200 bg-slate-50 pl-11 pr-4 py-3 text-sm focus:ring-2 focus:ring-[#1CA3B0]/50 focus:border-[#1CA3B0] outline-none transition-colors"
              data-testid="login-email"
              required
            />
          </div>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"><Lock size={16} /></span>
            <input
              type={showPass ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full rounded-lg border border-slate-200 bg-slate-50 pl-11 pr-11 py-3 text-sm focus:ring-2 focus:ring-[#1CA3B0]/50 focus:border-[#1CA3B0] outline-none transition-colors"
              data-testid="login-password"
              required
            />
            <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
              {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {error && <p className="text-red-500 text-sm" data-testid="login-error">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg py-3 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-50"
            style={{ background: 'linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)' }}
            data-testid="login-submit-button"
          >
            {loading ? "Duke hyre..." : "Hyr ne Panel"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
